import React from 'react';
import { Link} from 'react-router-dom';
import { Container } from 'react-bootstrap';

export const TermsOfUse: React.FC = () => {
  return (
    <div id="privacy" className="overflow-y-auto scrollbar-custom-y" style={{ height: "calc(100% - 80px)" }}>
            <Container>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <h2 style={{ fontSize: '1.5rem', fontWeight: 600, margin: 0 }}>Условия пользования</h2>
      </div>

      <p style={{ color: '#666', fontSize: '0.875rem', marginBottom: '16px' }}>
        Дата последнего обновления: 22 декабря 2025 г.
      </p>

        <p>
          Настоящие Условия пользования (далее — «Условия») регулируют отношения между вами (Пользователем) и
          разработчиком приложения <strong>«O!-Chat»</strong> при использовании данного программного продукта.
        </p>

        <h2 style={{ fontSize: '1.125rem', fontWeight: 600, marginTop: '24px', marginBottom: '12px' }}>
          1. Общие положения
        </h2>
        <p>
          Приложение «O!-Chat» — это мессенджер для личного общения, предназначенный для обмена текстовыми
          сообщениями, медиафайлами и получения уведомлений о новых сообщениях.
        </p>
        <p>
          Использование Приложения возможно только после прохождения авторизации и означает ваше полное согласие с
          настоящими Условиями.
        </p>

        <h2 style={{ fontSize: '1.125rem', fontWeight: 600, marginTop: '24px', marginBottom: '12px' }}>
          2. Права и обязанности пользователя
        </h2>
        <p>Вы обязуетесь:</p>
        <ul style={{ paddingLeft: '20px', marginTop: '8px' }}>
          <li>Использовать Приложение только в личных, некоммерческих целях;</li>
          <li>
            Не распространять через Приложение запрещённый контент (порнография, экстремизм, угрозы, спам и т.д.);
          </li>
          <li>Не пытаться взломать, модифицировать или автоматизировать работу Приложения;</li>
          <li>Не передавать свои учётные данные третьим лицам.</li>
        </ul>

        <h2 style={{ fontSize: '1.125rem', fontWeight: 600, marginTop: '24px', marginBottom: '12px' }}>
          3. Ограничение ответственности
        </h2>
        <p>Разработчик:</p>
        <ul style={{ paddingLeft: '20px', marginTop: '8px' }}>
          <li>
            Не несёт ответственности за временную недоступность Приложения по техническим или иным причинам;
          </li>
          <li>
            Не гарантирует сохранность ваших данных в случае утраты устройства или компрометации учётной записи;
          </li>
          <li>
            Оставляет за собой право приостановить работу Приложения без предварительного уведомления (например, для
            обновлений или по юридическим причинам).
          </li>
        </ul>

        <h2 style={{ fontSize: '1.125rem', fontWeight: 600, marginTop: '24px', marginBottom: '12px' }}>
          4. Интеллектуальная собственность
        </h2>
        <p>
          Все права на Приложение, включая код, дизайн, логотипы и интерфейс, принадлежат разработчику. Запрещается
          копирование, распространение или создание производных продуктов без письменного разрешения.
        </p>

        <h2 style={{ fontSize: '1.125rem', fontWeight: 600, marginTop: '24px', marginBottom: '12px' }}>
          5. Прекращение использования
        </h2>
        <p>
          Вы можете в любое время удалить Приложение и свой аккаунт. При этом все ваши данные (сообщения, чаты) будут
          удалены с серверов в течение 30 дней.
        </p>

        <h2 style={{ fontSize: '1.125rem', fontWeight: 600, marginTop: '24px', marginBottom: '12px' }}>
          6. Применимое право
        </h2>
        <p>
          Настоящие Условия регулируются законодательством Российской Федерации. Все споры разрешаются путём
          переговоров. В случае недостижения согласия — в соответствии с нормами российского права.
        </p>

        <h2 style={{ fontSize: '1.125rem', fontWeight: 600, marginTop: '24px', marginBottom: '12px' }}>7. Контакты</h2>
        <p>
          По всем вопросам, связанным с Приложением, вы можете обратиться по электронной почте: <br />
         <Link to="mailto:info@factfactor.ru">info@factfactor.ru</Link>
        </p>
      </Container>
    </div>
  );
};
